/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBadge8k = createReactComponent("badge-8k", "IconBadge8k", [
  [
    "path",
    {
      d: "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M14 9v6", key: "svg-1" }],
  ["path", { d: "M17 9l-2 3l2 3", key: "svg-2" }],
  ["path", { d: "M15 12h-1", key: "svg-3" }],
  [
    "path",
    {
      d: "M8.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1",
      key: "svg-4"
    }
  ]
]);

export { IconBadge8k as default };
//# sourceMappingURL=IconBadge8k.js.map
